<template>
  <div>
    <!--    <img src="./model.svg" alt="" style="width: 100%;">-->

    <div class="printBanner">
      <div style="height:170px; background-color: #a0a0a0;">
        <div class="container">
          <el-row :gutter="30" style="padding-top: 50px">
            <el-col :span="12" :offset="6" class="bannerSearch">
              <el-input size="large" placeholder="请输入内容" v-model="input" class="">
                <el-button slot="append" icon="el-icon-search" type="primary"></el-button>
              </el-input>
              <ul class="flex" style="font-size: 12px;">
                <li style="margin: 15px;">模型制造</li>
                <li style="margin: 15px;">铸件制造</li>
                <li style="margin: 15px;">紧密加工</li>
                <li style="margin: 15px;">3D打印设备</li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="container">
      <section style="padding-bottom: 60px">
        <div style="height:120px; margin: 30px 0; background-color: #F4F6F9;"></div>
        <el-row :gutter="30" class="content">
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="box-card" shadow="hover" :body-style="{ padding: '0px' }">
              <el-image
                      class="image"
                      :src="url"
                      :fit="cover">
              </el-image>
              <el-tag
                      class="mdfree"
                      effect="plain">
                免费
              </el-tag>
              <div style="padding: 15px">
                <h4 class="mdTitle">动漫手办<span class="mdTime">2小时前</span></h4>
                <p class="mdDetail">家具生活/家具-免费模型</p>
                <div class="mpNum">
                  <span><a href="#"><i class="el-icon-view" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-star-off" style="margin-right: 8px"></i>410</a></span>
                  <span><a href="#"><i class="el-icon-chat-dot-square" style="margin-right: 8px"></i>410</a></span>
                </div>
                <div class="mpFooter">
                  <div><el-avatar size="medium" src="circleUrl"></el-avatar> </div>
                  <span style="flex: 1; margin-left: 8px; font-size: 12px;">韩梅梅</span>
                  <div><el-button><i class="el-icon-download el-icon--right"></i>123</el-button></div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div style="text-align: right">
          <el-pagination
                  style="margin-right: -10px"
                  background
                  layout="prev, pager, next"
                  :total="50">
          </el-pagination>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    //   我要打印
    name: "print",
    components: {},
    data() {
      return {
        bannerList: [
          {
            value: require("../../assets/image/mxk.png"),
          },
        ],
      };
    },

    methods: {},
  };
</script>

<style scoped lang="less">
  .container {
    width: 1200px;
    margin: 0 auto;
  }
  .bannerSearch{
    /deep/.el-input__inner{
      height: 50px;
      line-height: 50px;
    }
    /deep/.el-input-group__append{
      background-color: #157EFB;
      color:#fff !important;
      font-size: 18px;
      border-color: transparent;
    }
  }
  .printTitle {
    font-size: 28px;
    font-weight: normal;
    color: rgba(0, 0, 0, 0.85);
    margin-top: 60px;
    margin-bottom: 15px;

  }
  .box-card {
    margin-bottom: 30px;
    position: relative;
    .image {
      width: 100%;
      height: 140px;
      display: block;
    }
    .mdfree{
      position: absolute;
      top:10px;
      left:10px;
      opacity: 0.75;
    }
  }

  .mdTitle {
    font-size: 16px;
    font-weight: normal;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 10px;
    span.mdTime {
      font-size: 12px;
      float: right;
      margin-top: 5px;
      color: #808080 !important;
    }
  }
  .mdDetail {
    font-size: 12px;
    margin-top: 10px;
  }
  .mpNum {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    span {
      display: inline-block;
      width: 50%;
      text-align: center;
      font-size: 12px;
      height: 50px;
      line-height: 50px;
    }
    span a {
      color: #808080;
    }
    span a:hover {
      color: rgba(21, 126, 251, 0.8);
    }
  }
  .mpFooter{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #EBEEF5;
    margin: 0 -21px -15px;
    padding:10px 20px;
    /deep/.el-button{
      color: #157EFB;
      border-color: #157EFB;
      padding: 6px 10px;
      font-size: 12px;
    }
  }
  /*.content{*/
  /*  /deep/.el-col-4 {*/
  /*    width: 20%*/
  /*  }*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/model/modelList.vue